<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      ip: null,

      client: null,
      package: null,
      packages: null,

      choose: {
        modal: false,
        loading: false,
        id: "",
        type: "",
        name: "",
        description: "",
        total: "",
        value: "",
        discount: 0,
      },
    };
  },
  methods: {
    getIp() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          if (data.ip) {
            this.ip = data.ip;
          }
        });
    },
    getPackages() {
      this.packages = null;

      api
        .get('packages')
        .then((response) => {
          if (response.data.status == 'success') {
            this.packages = response.data.list;
          }
        })
    },
    showChoose(pack) {
      this.choose.modal = false;
      this.choose.modal = true;
      this.choose.id = pack.id;
      this.choose.type = pack.type;
      this.choose.name = pack.name;
      this.choose.description = pack.description;
      this.choose.total = pack.total;
      this.choose.value = pack.value;
      this.choose.discount = pack.discount;
    },
    choosePackage() {
      if (this.choose.id) {
        this.choose.loading = true;

        api
          .post('packages/choose', {
            id: this.choose.id,
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.choose.modal = false;
              this.choose.loading = false;
              this.$router.push('/packages/' + response.data.order.id);
            } else {
              this.choose.modal = false;
              this.choose.loading = false;
            }
          })
          .catch((error) => {
            if (error) {
              this.choose.modal = false;
              this.choose.loading = false;
            }
          })
          .finally(() => {
            this.choose.modal = false;
            this.choose.loading = false;
          });
      }
    },
  },
  mounted() {
    this.getPackages()
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/packages">Pacotes</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Comprar</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Comprar</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!packages" class="text-center">
      <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
    </div>
    <div v-else-if="packages && packages.length > 0">
      <h5 class="mb-4">Escolha a melhor opção para você</h5>
      <div class="row">
        <div class="col-lg-4" v-for="(row, index) in packages" :key="index">
          <div class="card" :class="row.status == 'blocked' ? 'package-disabled' : ''">
            <div class="card-body text-center">
              <img v-if="row.cover" :src="row.cover" class="img-fluid mb-3" />
              <span class="badge badge-soft-success font-size-13" v-if="row.type == 'limpanome'">EXCLUSÃO JURÍDICA</span>
              <span class="badge badge-soft-primary font-size-13" v-else-if="row.type == 'exclusaoindividual'">EXCLUSÃO INDIVIDUAL</span>
              <span class="badge badge-soft-primary font-size-13" v-else-if="row.type == 'jusbrasil'">JUSBRASIL</span>
              <span class="badge badge-soft-primary font-size-13" v-else-if="row.type == 'bacen'">BACEN</span>
              <span class="badge badge-soft-primary font-size-13" v-else-if="row.type == 'audits'">AUDITORIAS</span>
              <h4 class="mb-0 text-default">{{ row.name }}</h4>
              <p v-if="row.total == 1">1 nome</p>
              <p v-else>{{ row.total }} nomes</p>
              <h4 class="mb-3 text-dark">{{ row.value | currency }}</h4>
              <div class="mb-1 text-default" v-html="row.description"></div>
              <button class="btn btn-default btn-block btn-lg text-uppercase" v-on:click="showChoose(row)">
                Escolher
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      Nenhum pacote disponível no momento.
    </div>

    <b-modal v-model="choose.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h4>Confirmar escolha</h4>
        <template v-if="choose.type == 'limpanome'">
          <p>Confirma a escolha do pacote <strong>Exclusão Jurídica</strong> – <strong>{{ choose.name }}</strong>?</p>
        </template>
        <template v-else-if="choose.type == 'exclusaoindividual'">
          <p>Confirma a escolha do pacote <strong>Exclusão Individual</strong> – <strong>{{ choose.name }}</strong>?</p>
        </template>
        <template v-else-if="choose.type == 'jusbrasil'">
          <p>Confirma a escolha do pacote <strong>JusBrasil</strong> – <strong>{{ choose.name }}</strong>?</p>
        </template>
        <template v-else-if="choose.type == 'bacen'">
          <p>Confirma a escolha do pacote <strong>Bacen</strong> – <strong>{{ choose.name }}</strong>?</p>
        </template>
        <template v-else-if="choose.type == 'audits'">
          <p>Confirma a escolha do pacote <strong>Auditorias</strong> – <strong>{{ choose.name }}</strong>?</p>
        </template>
        <h4 class="mb-4">{{ choose.value | currency }}</h4>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" v-on:click="choosePackage()" :disabled="this.choose.loading">
            Confirmar
            <b-spinner v-if="choose.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="choose.modal = false">Fechar</a>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>